import { observer } from 'mobx-react';
import { AdminEditModal } from '@code-yellow/spider';
import { PlanningTicket } from '../../store/planning/PlanningTicket';
import { UserStore } from '../../store/User';

const STATUS_OPTIONS = [
    { text: 'To Do', value: 'todo' },
    { text: 'In Progress', value: 'in_progress' },
    { text: 'Review', value: 'review' },
    { text: 'Done', value: 'done' },
    { text: 'Blocked', value: 'blocked' },
];

@observer
export default class TicketEditModal extends AdminEditModal {
    modalProps = { size: 'tiny' };

    Model = PlanningTicket;

    relations = ['milestone', 'assignee'];

    userStore = new UserStore();

    fields = [
        { type: 'text', name: 'title' },
        () => ({
            type: 'select',
            name: 'status',
            options: STATUS_OPTIONS,
        }),
        () => ({
            type: 'select',
            name: 'assignee',
            remote: true,
            store: this.userStore,
            toOption: (user: any) => ({ text: user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email, value: user.id }),
            clearable: true,
        }),
        { type: 'number', name: 'estimatedHours' },
        () => ({
            type: 'number',
            name: 'spentHours',
            readOnly: true,
            label: 'Spent Hours (tracked, read-only)',
        }),
        { type: 'date', name: 'scheduledStart', clearable: true },
        { type: 'date', name: 'scheduledEnd', clearable: true },
        { type: 'textArea', name: 'description' },
    ];
}
